import axios from 'axios'
import localforage from 'localforage'
import router from '../router'

const api = axios

api.defaults.baseURL = process.env.VUE_APP_API
api.defaults.headers.common.Accept = 'application/json'
api.defaults.headers.common['Content-Type'] = 'application/json'
api.defaults.headers.post['Content-Type'] = 'multipart/form-data'

api.interceptors.request.use(
    async config => {
        console.log('→ AXIOS REQ ', config.method.toUpperCase(), config.url)
        console.log('  data:   ', config.data)
        console.log('  params: ', config.params)
        console.log('  headers:', config.headers)
        return localforage.getItem('authToken').then(token => {
            if(token) {
                config.headers.common.Authorization = `Bearer ${token}`
            }
            return config
        })
    },
    error => {
        return Promise.reject(error)
    }
)

api.interceptors.response.use(
    response => {
        // handle new token
        if(response.data.access_token && response.data.access_token.token) {
            localforage.setItem('authToken', response.data.access_token.token).catch(error => {
                console.error(error)
            })
        }
        // access_token
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        if(error.response && error.response.status) {
            switch (error.response.status) {
            case 401:
                if(error.response.config.url !== 'client/v2/users/login') {
                    router.push({ name: 'dashboard-logout' }).catch(() => {})
                }
                break
            case 404:
                return Promise.reject(error)
            case 406:
                return Promise.reject(error)
            }
        }
        return Promise.reject(error)
    }
)

export default api
